/* @jsx h */
import { defineComponent, h, onMounted } from "vue";
import { PageComponent, useLocalization } from "@lemmonhq/uikit";
import { useShop } from "../../providers";
import { setTitle } from "@lemmonhq/orders";

export * from "./subpages";

export const ManagerReservationsPage = defineComponent({
  name: "ManagerReservationsPage",
  setup() {
    const { t } = useLocalization();
    const shop = useShop();
    onMounted(() => {
      shop.refreshData();
    });
    setTitle("Reservations");
    return () => {
      const subpages = [
        {
          name: t("reservations.nav.requests"),
          icon: "table_restaurant",
          href: "/app/manager/reservations",
        },
        {
          name: "Customers",
          icon: "group",
          href: "/app/manager/reservations/customers",
        },
        {
          name: t("reservations.nav.schedule"),
          icon: "calendar_month",
          href: "/app/manager/reservations/schedule",
        },
        {
          name: t("reservations.nav.history"),
          icon: "history",
          href: "/app/manager/reservations/history",
        },
        {
          name: t("reservations.nav.events"),
          icon: "celebration",
          href: "/app/manager/reservations/events",
        },
        {
          // Jump to the Tables floor plan, already in reservation (seating) mode.
          name: t("reservations.nav.floor_plan"),
          icon: "map",
          href: "/app/tables?mode=reservations",
        },
      ];
      return (
        <PageComponent
          title={t("reservations.general.reservation")}
          titleIcon="calendar_month"
          subpages={subpages}
        />
      );
    };
  },
});
